window.GameController = JunctionController.extend({
    blockCompleted: function(event) {
        var module = this.data.getModule(0);
        var totalPages = module.getTotalPages();
        var currentPageNumber = this.currentPageNumber + 1;
        if (currentPageNumber < totalPages) {
            if (!this.instance.isCompleted) {
                var page = this.data.getModule(0).getPage(currentPageNumber);
                //this.app.storage.setItem(GameJunction.BOOKMARK, page.pageID());
            } else {
                //this.app.storage.deleteItem(GameJunction.BOOKMARK);
            }
        }
        this.trigger("onBlockCompleted", event);
    },
    previous: function() {
        if (this.isDestroyed) return false;

        if (!this.currentModuleNumber && this.currentModuleNumber !== 0) {
            return false;
        }

        if (this.currentPageNumber - 1 >= 0) {
            var page = this.data.getModule(this.currentModuleNumber).getPage(this.currentPageNumber - 1);
            this.routeToPage(page.pageID());
        } else {
            this.isPreviousClicked = true;
            this.endModule();
        }
    },
});
